import { URI_VEHICLE_SCAN } from '@/config/config'

export default async ({ rootState, state }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const client = rootState['DATA-ACCESS'].client;

  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      clientid: client._id
    },
  }

  const userLoginInfoResult = await fetch(`${URI_VEHICLE_SCAN}empro/list-zones-areas-parkings`, opts)
  const jsonResult = await userLoginInfoResult.json()
  state.zones = jsonResult.zones
  state.areas = jsonResult.areas
  state.parkings = jsonResult.parkings
  
  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }
  
  return jsonResult
}